var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"layoutC"},[_c('router-link',{staticClass:"btn",attrs:{"to":`/mypage/${ _vm.id }/`}},[_c('span',[_vm._v("マイページに戻る")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }